import { LoginComponent } from '@app/account/login/login.component';
import { MainmenuComponent } from './mainmenu/mainmenu.component';
import { RegisterComponent } from './member/register/register.component';
import { HomeComponent } from './home/home/home.component';
import { MemberImportComponent } from './member/member-import/member-import.component';
import { MemberAcountPermisstionComponent } from './member/member-acount-permisstion/member-acount-permisstion.component';
import { MembertypeComponent } from './member/membertype/membertype.component';
import { PositionComponent } from './member/position/position.component';
import { DepartmentComponent } from './member/department/department.component';
import { CreateQrcodeComponent } from './member/create-qrcode/create-qrcode.component';
import { ProfileComponent } from './profile/profile.component';
import { ContactReportComponent } from './contact-report/contact-report.component';
import { ProfileRegisterComponent } from './profile-register/profile-register.component';
import { TicketListComponent } from './ticket/ticket-list/ticket-list.component';
import { ResetPasswordComponent } from './account/reset-password/reset-password.component';
import { ReqDocumentComponent } from './req-document/req-document.component';
import { PreReqDocumentComponent } from './pre-req-document/pre-req-document.component';
var appRoutes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'resetpassword', component: ResetPasswordComponent },
    { path: 'mainmenu', component: MainmenuComponent /*, canActivate: [AuthGuard]*/,
        children: [
            { path: 'home', component: HomeComponent /*, canActivate: [AuthGuard]*/ },
            //Member
            { path: 'member-register', component: RegisterComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'member-import', component: MemberImportComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'member-membertype', component: MembertypeComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'member-position', component: PositionComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'member-department', component: DepartmentComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'member-create-qrcode', component: CreateQrcodeComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'member-account-permisstion', component: MemberAcountPermisstionComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'contactReport', component: ContactReportComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'profile', component: ProfileComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'register', component: ProfileRegisterComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'ticketlist', component: TicketListComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'reqdocument', component: ReqDocumentComponent /*, canActivate: [AuthGuard]*/ },
            { path: 'prereqdocument', component: PreReqDocumentComponent /*, canActivate: [AuthGuard]*/ },
        ]
    }
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js